export const VectorDesktop = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="197"
        height="100"
        viewBox="0 0 197 100"
        fill="none"
      >
        <path
          d="M2.88035 2.91431C75.2515 14.7113 256.908 46.5479 172.29 92.8547M174.868 79.7941L168.224 93.9063L186.546 97.1308"
          stroke="#FD65EB"
          strokeWidth="4.43875"
          strokeLinecap="round"
        />
      </svg>
    );
  };


  export const VectorMobile = () => {
    return (
      <svg
    width="111"
    height="107"
    viewBox="0 0 111 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5003 36.3043C50 30.8043 87 50.8043 77.795 70.7136M74.6038 65.5641L76.7667 72.3247L83.8693 67.7173"
      stroke="#FD65EB"
      strokeWidth="2.01994"
      strokeLinecap="round"
    />
  </svg>
    );
  };